import React, { useEffect, useRef, useState } from "react";
import BgPattern from "../components/BgPattern";
import LoadingScreen from "../components/Loading";
import ConfettiBG from "../components/ConfettiBg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getMessages } from "../service/db";
import Logo from "../components/Logo";


const MessageGrid = () => {
	const [showLoading, setshowLoading] = useState(true);
	const [messages, setmessages] = useState([]);
    const [totalMessages, setTotalMessages] = useState(0);
	const [selectedMessage, setSelectedMessage] = useState(null);
	const [currentPage, setCurrentPage] = useState(1); // New state for current page
	// const [showPopup, setShowPopup] = useState(false); // New state for popup visibility

	// const { uid } = useParams();
	const navigate = useNavigate();

	const uid = useRef();
	const location = useLocation();

	useEffect(() => {
		const urlParams = new URLSearchParams(location.search);
		uid.current = urlParams.get("uid");
		const checkUser = async () => {
			if (!uid.current) {
				navigate("/");
				return;
			}
		};

		checkUser();
		setshowLoading(false);
		fetchMessages(currentPage); // Fetch messages for the initial page

		

		return () => {
		
		};
	}, [currentPage, uid, navigate]);

	const fetchMessages = async (page) => {
		setshowLoading(true);
		getMessages(uid.current, page, 10, async (res) => {
			try{
				const resp = await res.json();
				setTotalMessages(resp["total_messages"])
				const msgs = resp["messages"]
				setmessages([...msgs]);
				setshowLoading(false);
			} catch(e) {
				console.log(e);
				navigate("/")
			}
			
		},(e)=>{
			console.log(e);
			navigate("/");
		});
	};

	const handleBoxClick = (message) => {
   
		setSelectedMessage(message);
		navigate(`/view?uid=${uid.current}`, {
			state: {
				message: message,
			},
		});
		// setShowPopup(true);
	};

	const handlePageChange = (newPage) => {
		setCurrentPage(newPage);
	};

	return (
		<div className="relative flex  w-full  h-full">
			<BgPattern rotate className="bg-[#0b0022] absolute h-full w-full z[-1]"></BgPattern>
			<ConfettiBG></ConfettiBG>
			<div className="w-full h-full overflow-y-scroll pb-2 z-[50] flex flex-col items-center">
				<LoadingScreen show={showLoading}></LoadingScreen>
				<h1 className="text-white text-4xl md:text-4xl font-bold pt-6">TellMeBefore24</h1>
				<h1 className="text-white text-xl md:text-xl font-bold ">You got {totalMessages} messages</h1>

				<div className="w-full h-fit grid grid-cols-2 grid-rows-3 md:grid-cols-4 lg:grid-cols-3 justify-center items-center lg:px-[20%] xl:grid-cols-5 xl:px-[20%] gap-4 p-4 ">
					{messages.map((message, index) => (
						<div onClick={() => handleBoxClick(message)} className="flex flex-col w-[100%] items-center gap-2" key={index}>
							<div className="bg-[#4b3c7b] shadow-lg text-white h-[150px] w-full max-w-[200px] max-h-[200px] rounded-md p-4 cursor-pointer font-bold overflow-hidden">
								<div className="overflow-hidden text-ellipsis whitespace-wrap">{message}</div>
							</div>
						</div>
					))}
				</div>

				<div className="flex relative  justify-center mt-4">
					<button className="bg-[#e1d8ff] text-black px-4 py-2 rounded-md mr-2 disabled:bg-[#9489b9]" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
						Prev
					</button>
					<span className="text-white font-bold h-full text-center flex flec-col  items-center">{`Page ${currentPage}`}</span>
					<button
						className="bg-[#e1d8ff] text-black px-4 py-2 rounded-md ml-2 disabled:bg-[#9489b9]"
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={messages.length < 10} // Assuming 100 is the page size
					>
						Next
					</button>
				</div>
			</div>
		</div>
	);
};

export default MessageGrid;
